<template>
  <div style="text-align: center; padding: 100px;">
    <h1>404 - 页面未找到</h1>
    <p>您访问的页面不存在，请返回首页或联系管理员。</p>
    <el-button type="primary" @click="$router.push('/home')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>



// WEBPACK FOOTER //
// src/views/404/NotFound.vue